export default "__VITE_ASSET__CrXKTqac__"